import * as ActionType from '../../core/ActionType';

/**
 * 
 * @param {mensagens de erro} messages 
 */
export const setErrorResponse = messages => ({
    type: ActionType.API_CALL_ERROR,
    messages
});

export const setSuccessResponse = messageSuccess => ({
    type: ActionType.API_CALL_SUCCESS,
    messageSuccess
});